import React from "react";
import { useTranslation } from "react-i18next";
import ReactSwitch from "react-switch";
import { useSnapshot } from "valtio";

import {
    setTicketHeaderSaleModeBold,
    setTicketHeaderSaleModeBlackBackround,
    setTicketHeaderName_phone_number_bold,
    setTicketHeaderLogoKitchen,
    setTicketHeaderLogoCustomer,
    setTicketHeaderPathCustomer,
    setTicketHeaderPathKitchen,
    StoreGeneral,
    setTicketHeaderStyleOrderNumber,
    orchestratorStore as localStore,
} from "@components/Common/PrinterSetting/stores";

import "../index.css";
import { Uploader } from "@pages/ApplicationSetting/General/upload";
import classNames from "classnames";

import { PrinterRowData } from "../../types";
import { PRINTER_TICKET_TYPE } from "../../constants";

type TicketHeaderType = {
    rowData?: PrinterRowData;
};

export default function TicketHeader({ rowData }: TicketHeaderType) {
    const { t } = useTranslation();
    const { checkboxIconSecondModel } = useSnapshot(localStore);

    const ticketValue = rowData?.tickets?.value;
    const isCustomerPrinter = ticketValue === PRINTER_TICKET_TYPE.CUSTOMER;
    const isKitchenPrinter =
        ticketValue === PRINTER_TICKET_TYPE.PRODUCTION ||
        ticketValue === PRINTER_TICKET_TYPE.STICKER ||
        ticketValue === PRINTER_TICKET_TYPE.VOUCHER;
    const {
        ticketHeaderSaleModeBlackBackround,
        ticketHeaderSaleModeBold,
        ticketHeaderName_phone_number_bold,
        ticketHeaderPathCustomer,
        ticketHeaderPathKitchen,
        ticketHeaderLogoCustomer,
        ticketHeaderLogoKitchen,
        ticketHeaderStyleOrderNumber,
    } = useSnapshot(StoreGeneral);
    return (
        <React.Fragment>
            <div className="d-flex  align-items-center justify-content-between px-1 pt-2 pb-1">
                <b>{t("Ticket header")}</b>
            </div>
            <div className="d-flex  align-items-center justify-content-between p-1">
                <div>{t("Print sale mode in bold")}</div>
                <div className=" float-right mr-4">
                    <ReactSwitch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={ticketHeaderSaleModeBold}
                        onChange={(e: any) => {
                            setTicketHeaderSaleModeBold(
                                !ticketHeaderSaleModeBold
                            );
                        }}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                        aria-label={t("Print sale mode in bold")}
                        data-testid="printer-setting-general-sale-mode-bold-switch"
                    />
                </div>
            </div>
            <div className="d-flex  align-items-center justify-content-between p-1">
                <div>{t("Print sale mode in  with black background")}</div>
                <div className=" float-right mr-4">
                    <ReactSwitch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={ticketHeaderSaleModeBlackBackround}
                        onChange={(e: any) => {
                            setTicketHeaderSaleModeBlackBackround(
                                !ticketHeaderSaleModeBlackBackround
                            );
                        }}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                        aria-label={t(
                            "Print sale mode in  with black background"
                        )}
                        data-testid="printer-setting-general-sale-mode-black-bg-switch"
                    />
                </div>
            </div>
            <div className="d-flex  align-items-center justify-content-between p-1">
                <div>{t("Print company name and phone number in bold")}</div>
                <div className=" float-right mr-4">
                    <ReactSwitch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={ticketHeaderName_phone_number_bold}
                        onChange={(e: any) => {
                            setTicketHeaderName_phone_number_bold(
                                !ticketHeaderName_phone_number_bold
                            );
                        }}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                        aria-label={t(
                            "Print company name and phone number in bold"
                        )}
                        data-testid="printer-setting-general-name-phone-bold-switch"
                    />
                </div>
            </div>
            <div
                className={`${classNames(
                    "d-flex  align-items-center justify-content-between p-1",
                    {
                        "not-allowed-icon__clz": checkboxIconSecondModel,
                    }
                )}`}
            >
                <div>
                    {t("Print the order number in bold and with a larger size")}
                </div>
                <div className=" float-right mr-4">
                    <ReactSwitch
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={ticketHeaderStyleOrderNumber}
                        onChange={(e: any) => {
                            setTicketHeaderStyleOrderNumber(
                                !ticketHeaderStyleOrderNumber
                            );
                        }}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={55}
                        height={20}
                        className="afa_icn_boldSaleMode"
                        aria-label={t(
                            "Print the order number in bold and with a larger size"
                        )}
                        data-testid="printer-setting-general-order-number-style-switch"
                    />
                </div>
            </div>
            {isCustomerPrinter && (
                <>
                    <div className="d-flex  align-items-center justify-content-between p-1">
                        <div>{t("Print logo on customer receipt")}</div>
                        <div className=" float-right mr-4">
                            <b>
                                <ReactSwitch
                                    uncheckedIcon={false}
                                    checkedIcon={false}
                                    handleDiameter={26}
                                    offColor="#f7b4b8"
                                    offHandleColor="#E30613"
                                    checked={ticketHeaderLogoCustomer}
                                    onChange={(e: any) => {
                                        setTicketHeaderLogoCustomer(
                                            !ticketHeaderLogoCustomer
                                        );
                                    }}
                                    onColor="#c2eddd"
                                    onHandleColor="#34C38F"
                                    width={55}
                                    height={20}
                                    aria-label={t(
                                        "Print logo on customer receipt"
                                    )}
                                    data-testid="printer-setting-general-logo-customer-switch"
                                />
                            </b>
                        </div>
                    </div>
                    <div className="d-flex  align-items-center justify-content-between p-1">
                        <Uploader
                            active={ticketHeaderLogoCustomer}
                            file={ticketHeaderPathCustomer}
                            setFile={setTicketHeaderPathCustomer}
                            ticketType="logoCustomer"
                            disabled={!ticketHeaderLogoCustomer}
                        />
                    </div>
                </>
            )}

            {isKitchenPrinter && (
                <>
                    <div className="d-flex  align-items-center justify-content-between p-1">
                        {t("Print logo on kitchen ticket")}
                        <div className=" float-right mr-4">
                            <ReactSwitch
                                uncheckedIcon={false}
                                checkedIcon={false}
                                handleDiameter={26}
                                offColor="#f7b4b8"
                                offHandleColor="#E30613"
                                checked={ticketHeaderLogoKitchen}
                                onChange={(e: any) => {
                                    setTicketHeaderLogoKitchen(
                                        !ticketHeaderLogoKitchen
                                    );
                                }}
                                onColor="#c2eddd"
                                onHandleColor="#34C38F"
                                width={55}
                                height={20}
                                aria-label={t("Print logo on kitchen ticket")}
                                data-testid="printer-setting-general-logo-kitchen-switch"
                            />
                        </div>
                    </div>
                    <div className="d-flex  align-items-center justify-content-between p-1">
                        <Uploader
                            active={ticketHeaderLogoKitchen}
                            file={ticketHeaderPathKitchen}
                            setFile={setTicketHeaderPathKitchen}
                            ticketType="logoKitchen"
                            disabled={!ticketHeaderLogoKitchen}
                        />
                    </div>
                </>
            )}
        </React.Fragment>
    );
}
